import { render, staticRenderFns } from "./FeaturedMemberBuilder.vue?vue&type=template&id=32f8e5f1&"
import script from "./FeaturedMemberBuilder.vue?vue&type=script&lang=js&"
export * from "./FeaturedMemberBuilder.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedMemberBuilder.vue?vue&type=style&index=0&id=32f8e5f1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports